function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#053927;}\r\n\t.st1{fill:#E2D4AC;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#C4B581;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "head"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_6_",
  className: "st0",
  d: "M122.3,220c-35.4-0.5-55,25.8-58.2,58.5c-10.2,1-16.4,1.6-25.4,2.5c-2.6-11-4.2-24.4-4.7-30.7 c-1.1-15,1-22.2,6.8-32.7c9.1-16.2,24-21.3,37.1-22.6C98.6,193,117.8,206,122.3,220z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "eye"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_31_",
  className: "st1",
  d: "M123.2,224.4c-29.5-1.1-50.9,22.2-55.1,53.9C112.7,280.9,132.4,267.2,123.2,224.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_30_",
  className: "st2",
  d: "M76,189.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_27_",
  className: "st2",
  d: "M76,200.1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "right_x5F_wing"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_19_",
  className: "st3",
  d: "M129.6,208.9c8.7,12.5,11.5,42.7,1,59.5c0,0,108.4-105.1,128.4-130.2 c15.4-22.2,19.4-87.6-0.7-123.1L129.6,208.9z"
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_26_",
  className: "st2",
  x1: 133.5,
  y1: 269.8,
  x2: 74.2,
  y2: 240
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_25_",
  className: "st2",
  x1: 74.2,
  y1: 241,
  x2: 133.5,
  y2: 211.2
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "left_x5F_wing"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_9_",
  className: "st3",
  d: "M81.3,185.4c-19.1,0.1-33.2,6.6-45.4,23.8c0,0-1.7-112.6,7-131.6C54.2,53,76.1,20.2,116.6,15.1 L81.3,185.4z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_10"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_24_",
  className: "st0",
  d: "M149.2,267.8l47.9-44.6l41.7-28.4c4.6,15,0.8,27.6-6.4,36.7c0,0,13.7,7.8,13,39.3 c-16.3-17.7-29.7-18.6-29.7-18.6C199.9,267,169,273.2,149.2,267.8z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2fe0e1d1.svg";
export { ForwardRef as ReactComponent };